export default function Testimonials() {
  const testimonials = [
    {
      name: 'Michael Rodriguez',
      location: 'Homeowner',
      rating: 5,
      text: 'Papi\'s Paving transformed our driveway beyond our expectations. The team was professional, punctual, and the quality of work is outstanding. Our neighbors keep asking who did the work!',
      image: 'https://public.readdy.ai/ai/img_res/9d1fa966e4e70bdd9c726eb49cd4a525.jpg'
    },
    {
      name: 'Sarah Thompson',
      location: 'Property Owner',
      rating: 5,
      text: 'We hired Papi\'s Paving for our backyard patio and couldn\'t be happier. They listened to our ideas, provided expert suggestions, and delivered a beautiful outdoor space perfect for entertaining.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20photograph%20of%20cheerful%20blonde%20woman%20in%20her%20forties%20with%20warm%20smile%20wearing%20light%20colored%20blouse%20standing%20in%20front%20of%20modern%20home%20exterior%20soft%20natural%20daylight%20high%20quality%20headshot&width=200&height=200&seq=testimonial002&orientation=squarish'
    },
    {
      name: 'David Chen',
      location: 'Residential Client',
      rating: 5,
      text: 'From start to finish, the experience was excellent. Fair pricing, quality materials, and skilled craftsmanship. The retaining wall they built has completely transformed our sloped yard.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20photograph%20of%20confident%20Asian%20man%20with%20black%20hair%20and%20glasses%20wearing%20navy%20polo%20shirt%20smiling%20warmly%20outdoors%20with%20suburban%20home%20background%20natural%20daylight%20high%20quality%20headshot&width=200&height=200&seq=testimonial003&orientation=squarish'
    },
    {
      name: 'Jennifer Martinez',
      location: 'Homeowner',
      rating: 5,
      text: 'Exceptional service and beautiful results! They installed our walkway and flower bed borders with such attention to detail. The project was completed on time and within budget.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20photograph%20of%20smiling%20Hispanic%20woman%20with%20long%20dark%20wavy%20hair%20wearing%20green%20cardigan%20standing%20near%20beautiful%20garden%20with%20flowers%20soft%20afternoon%20lighting%20high%20quality%20headshot&width=200&height=200&seq=testimonial004&orientation=squarish'
    },
    {
      name: 'Robert Williams',
      location: 'Property Owner',
      rating: 5,
      text: 'I\'ve worked with several paving companies over the years, and Papi\'s Paving is by far the best. Their expertise and commitment to quality are evident in every aspect of their work.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20photograph%20of%20mature%20African%20American%20man%20with%20gray%20beard%20wearing%20plaid%20shirt%20and%20confident%20smile%20standing%20outdoors%20with%20residential%20property%20background%20warm%20natural%20lighting%20high%20quality%20headshot&width=200&height=200&seq=testimonial005&orientation=squarish'
    },
    {
      name: 'Amanda Foster',
      location: 'Residential Client',
      rating: 5,
      text: 'Our new patio is absolutely gorgeous! The team was respectful of our property, cleaned up thoroughly each day, and the final result exceeded our expectations. Highly recommend!',
      image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20photograph%20of%20young%20woman%20with%20red%20hair%20and%20bright%20smile%20wearing%20casual%20denim%20jacket%20standing%20in%20front%20of%20contemporary%20house%20with%20clean%20background%20sunny%20daylight%20high%20quality%20headshot&width=200&height=200&seq=testimonial006&orientation=squarish'
    }
  ];

  return (
    <section id="testimonials" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            What Our <span className="text-purple-600">Clients Say</span>
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto px-4">
            Don't just take our word for it. Here's what our satisfied customers have to say about their experience with Papi's Paving.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-white rounded-lg p-6 sm:p-8 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
            >
              <div className="flex items-center mb-6">
                <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-full overflow-hidden mr-4 flex-shrink-0">
                  <img 
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 text-sm sm:text-base">{testimonial.name}</h4>
                  <p className="text-xs sm:text-sm text-gray-600">{testimonial.location}</p>
                </div>
              </div>
              
              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-green-500 text-base sm:text-lg"></i>
                ))}
              </div>
              
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed italic">
                "{testimonial.text}"
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-flex flex-col sm:flex-row items-center gap-6 sm:gap-8 bg-white rounded-lg shadow-lg p-6 sm:p-8">
            <div className="text-center">
              <div className="text-3xl sm:text-4xl font-bold text-purple-600 mb-2">4.9/5</div>
              <div className="text-xs sm:text-sm text-gray-600">Average Rating</div>
              <div className="flex justify-center mt-2">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-green-500 text-sm sm:text-base"></i>
                ))}
              </div>
            </div>
            <div className="h-px w-16 sm:h-16 sm:w-px bg-gray-300"></div>
            <div className="text-center">
              <div className="text-3xl sm:text-4xl font-bold text-purple-600 mb-2">250+</div>
              <div className="text-xs sm:text-sm text-gray-600">Happy Customers</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
